import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

export const GlobalStyle = createGlobalStyle`

${normalize}


html,
body {
  /* overflow: hidden; */
  /* font-size: 14px; */
  /* width: 1440px; */
  /* margin: 0 auto; */
}

h3 {
  font-size: 16px;
}

* {
  /* box-sizing: border-box; */
  /* font-family: 'Spoqa Han Sans Neo', 'sans-serif'; */
  font-family: -apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', Pretendard, Roboto, 'Noto Sans KR', 'Segoe UI', 'Malgun Gothic', sans-serif;
}

/* .ant-table table {
  font-size: 13px;
}
.ant-table-thead > tr > th {
  height: 5px;
  padding: 4px;
}
.ant-table-tbody > tr > td {
  height: 5px;
  padding: 4px;
} */

.clickable-table-item:hover {
  text-decoration: underline;
  color: #4b74ff;
  cursor: pointer;
}

span.ant-tag {
  font-size: 15px;
}

.hg-list-item:hover {
  text-decoration: underline;
  color: #4b74ff;
  cursor: pointer;
}

`;
